import React, { useEffect, useState } from "react";
import { Moon } from "lucide-react";
import api, { resolveImage } from "@/lib/api";

/**
 * Small circular avatar of "Moon", the site's stylist persona.
 * Falls back to a gold Moon icon inside a cream circle when no
 * admin-uploaded avatar is present at site_images.moon_avatar.
 *
 * Keep this deliberately small — she should NEVER appear as a large image.
 */
export default function MoonAvatar({ size = 32, className = "" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/site-images")
      .then(({ data }) => {
        if (alive && data?.moon_avatar) setSrc(resolveImage(data.moon_avatar, { w: 160 }));
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const style = { width: size, height: size };

  if (src) {
    return (
      <span
        style={style}
        className={`inline-block rounded-full overflow-hidden border border-sj-gold/40 shadow-sm shrink-0 ${className}`}
        data-testid="moon-avatar"
      >
        <img src={src} alt="Moon" className="w-full h-full object-cover" loading="lazy" />
      </span>
    );
  }

  return (
    <span
      style={style}
      className={`inline-flex items-center justify-center rounded-full bg-gradient-to-br from-sj-cream to-white border border-sj-gold/40 shadow-sm shrink-0 ${className}`}
      data-testid="moon-avatar-fallback"
      aria-label="Moon"
    >
      <Moon size={Math.max(12, Math.round(size * 0.5))} className="text-sj-goldDark" strokeWidth={1.5} />
    </span>
  );
}
